import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PrivacyContentPl } from '../../content/privacy.pl';
import { PublicLayout } from '../publicBooking/PublicLayout';

export function PrivacyPage(): ReactNode {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="mb-6">
        <Link to="/rezerwacja" className="text-sm text-brand-700 hover:text-brand-800 dark:text-brand-300 dark:hover:text-brand-200">
          ← {t('privacy.backToBooking')}
        </Link>
      </div>
      <div className="rounded-xl bg-white p-6 shadow-sm ring-1 ring-zinc-200 dark:bg-zinc-900 dark:ring-zinc-800 sm:p-8">
        <PrivacyContentPl />
      </div>
    </PublicLayout>
  );
}
